module.exports.ladySea = {
  vi: {
    title: 'Tiên nữ biển trong Avalon: luật và vai trò được tiết lộ',
    description:
      'Tìm hiểu Tiên nữ biển khác Tiên nữ hồ thế nào: thời điểm kiểm tra, kết quả vai Ác, lời khai công khai và ngoại lệ của Kẻ lừa lọc, Kẻ gây rối.',
    keywords: ['Tiên nữ biển trong Avalon', 'Luật chơi', 'Tiết lộ vai trò'],
  },
  pt: {
    title: 'Dama do Mar em Avalon: regras e personagens revelados',
    description:
      'Como a Dama do Mar difere da Dama do Lago: momento da verificação, personagens do mal, anúncios e exceções de Trickster e Troublemaker.',
    keywords: ['Dama do Mar em Avalon: regras e personagens revelados'],
  },
  en: {
    title: 'Lady of the Sea in Avalon: rules and revealed roles',
    description:
      'Learn how Lady of the Sea differs from Lady of the Lake: check timing, evil role results, public claims, and Trickster and Troublemaker exceptions.',
    keywords: ['Lady of the Sea in Avalon: rules and revealed roles'],
  },
  ru: {
    title: 'Леди Моря в Авалоне: правила и раскрытие злых ролей',
    description:
      'Чем Леди Моря отличается от Леди Озера: время проверки, раскрытие злой роли, объявления и исключения для Трикстера и Траблмейкера.',
    keywords: ['Леди Моря в Авалоне: правила и раскрытие злых ролей'],
  },
  'zh-TW': {
    title: '阿瓦隆海中仙女：查驗規則與壞人角色資訊',
    description:
      '海中仙女和湖中仙女有什麼差別？了解阿瓦隆本站的查驗時機、壞人角色顯示、公開聲明，以及詭術師和搗蛋鬼的例外。',
    keywords: ['阿瓦隆海中仙女：查驗規則與壞人角色資訊'],
  },
  'zh-CN': {
    title: '阿瓦隆海中仙女：查验规则与坏人角色信息',
    description:
      '海中仙女和湖中仙女有什么区别？了解阿瓦隆本站的查验时机、坏人角色显示、公开声明，以及诡术师和捣蛋鬼的例外。',
    keywords: ['阿瓦隆海中仙女：查验规则与坏人角色信息'],
  },
  es: {
    title: 'Dama del Mar en Avalon: reglas y personajes revelados',
    description:
      'Diferencias entre Dama del Mar y Dama del Lago: cuándo consultar, qué personajes revela y las excepciones de Trickster y Troublemaker.',
    keywords: ['Dama del Mar en Avalon: reglas y personajes revelados'],
  },
};
